import { FilterType } from './enums';
import { IColumnFilter } from './interfaces/ITable';

export const DEFAULT_LANGUAGE = 'en';

export const NOTIFICATION_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed'
};

export const FILE_TYPES = {
  basicImg: '.jpg, .png, .jpeg, .gif, .heic',
  img: 'jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff, .webp|image/*',
  docs: '.doc, .docx',
  excel: '.xls, .xlsx',
  files: '.jpg, .png, .jpeg, .gif, .docs, .pdf, .docx, .xlsx, .txt, .heic'
};

export const REGEX_PATTERNS = {
  EMAIL: '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$',
  PHONE: '^(\\+?[1-9]\\d{0,2})?\\s?\\(?\\d{1,4}\\)?\\s?\\d{1,4}[-\\s]?\\d{1,4}[-\\s]?\\d{1,9}$',
  DATE: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/,
  TIME: /(2[0-3]|[01][0-9]):[0-5][0-9]/
};

export const DATE_PICKER_LOCALE = 'nb-NO';

export const DATE_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY'
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'DD.MM.YYYY',
    dateA11yLabel: 'DD.MM.YYYY',
    monthYearA11yLabel: 'DD.MM.YYYY'
  }
};

export const ROUTES = {
  USER: {
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    PROCESS: '/pef-database',
    EULA: '/eula',
    INFORMATION: '/information'
  },
  ADMIN: {
    LOGIN: '/admin',
    DASHBOARD: '/admin/dashboard',
    FORGOT_PASSWORD: '/admin/forgot-password',
    SYSTEM: '/admin/system',
    PROCESS: '/admin/pef-database',
    INBOUND_DATASETS: '/admin/inbound-datasets',
    USER: '/admin/user',
    USER_ADMIN: '/admin/user-admin',
    COMPANIES: '/admin/companies',
    COUNTRIES: '/admin/system/country',
    ALLOCATION_TYPE: '/admin/system/allocation-type',
    DATA_PROVIDER: '/admin/system/data-provider',
    DATASET_TYPE: '/admin/system/dataset-type',
    DATASET_UNIT: '/admin/system/dataset-unit',
    DATA_SOURCE: '/admin/system/data-source',
    JOBS: '/admin/jobs',
    JOBS_PROCESS_DATA: '/admin/jobs/process-data',
    EULA: '/admin/eula',
    INFORMATION: '/admin/information',
    DOCUMENTS: '/admin/documents',
    CREDENTIALS: '/admin/credentials',
    LOGS: '/admin/logs',
  }
};

export const LANGUAGES = [
  {
    language: 'English',
    code: 'en',
    icon: '/assets/images/flag/icon-flag-en.svg'
  },
  {
    language: 'Norsk',
    code: 'no',
    icon: '/assets/images/flag/icon-flag-no.svg'
  },
  {
    language: 'Español',
    code: 'es',
    icon: '/assets/images/flag/icon-flag-es.svg'
  },
  {
    language: 'Deutsch',
    code: 'de',
    icon: '/assets/images/flag/icon-flag-de.svg'
  },
  {
    language: 'Français',
    code: 'fr',
    icon: '/assets/images/flag/icon-flag-fr.svg'
  }
];

export const PATTERN = {
  EMAIL: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
  PHONE: '^(\\+?[1-9]\\d{1,14}|0\\d{9,14})$',
  PASSWORD: '^(?=.*[A-Z])(?=.*\\d)(?=.*[!?*.@]).{8,}$',
  NUMBER: /^-?\d+(\.\d+)?$/,
  DECIMAL_13_9: /^-?\d{1,4}(\.\d{1,9})?$/,
  DECIMAL_24_12: /^-?\d{1,12}(\.\d{1,12})?$/,
  ZIP_GENERIC: /^[A-Za-z0-9][A-Za-z0-9\- ]{2,9}$/
};
export const TABLE_STYLES = {
  STRIPED: 'STRIPED',
  SOLID: 'SOLID',
  EXPAND_CONTAINER: 'EXPAND_CONTAINER',
  EXPAND_TREE: 'EXPAND_TREE'
};

export const FILTER_COLUMN_TYPE = {
  FILTER: 'filter',
  RESET: 'reset'
};

export const PARAM_OPERATOR = {
  LIKE: 'like',
  EQUAL: 'equal',
  NOT_EQUAL: 'notequal',
  GREATER_THAN: 'greaterThan',
  LESS_THAN: 'lessThan',
  GREATER_THAN_OR_EQUAL: 'greaterThanOrEqual',
  LESS_THAN_OR_EQUAL: 'lessThanOrEqual',
  IN: 'in'
};

export const COLORS = {
  PRIMARY: '#007bff',
  SECONDARY: '#6c757d',
  SUCCESS: '#28a745',
  DANGER: '#ff5454',
  WARNING: '#ffc107',
  INFO: '#17a2b8',
  LIGHT: '#f8f9fa',
  DARK: '#343a40',
  BORDER: '#0000001f',
  MAIN_THEME: '#5d87ff',
  GREEN_LOGO: '#6cbe00',
  WHITE: '#ffffff',
  TRANSPARENT: '#00000000',
  AVATAR_TEXT: '#7d3bcb',
  AVATAR_BG: '#e6d6fc',
  MUTED: '#6c757d',
  BLUE: '#0854a0'
};

export const TABLE_COLUMN_FILTER_LIST: IColumnFilter[] = [
  {
    name: 'contains',
    paramOperator: PARAM_OPERATOR.LIKE,
    filterType: [FilterType.TEXT],
    icon: '/assets/images/svgs/operators/search.svg'
  },
  {
    name: 'equals',
    paramOperator: PARAM_OPERATOR.EQUAL,
    filterType: [FilterType.TEXT, FilterType.DATE, FilterType.NUMBER],
    icon: '/assets/images/svgs/operators/equal.svg'
  },
  {
    name: 'no equal',
    paramOperator: PARAM_OPERATOR.NOT_EQUAL,
    filterType: [FilterType.DATE, FilterType.NUMBER],
    icon: '/assets/images/svgs/operators/equal-not.svg'
  },
  {
    name: 'greater than',
    paramOperator: PARAM_OPERATOR.GREATER_THAN,
    filterType: [FilterType.DATE, FilterType.NUMBER],
    icon: '/assets/images/svgs/operators/greater-than.svg'
  },
  {
    name: 'less than',
    paramOperator: PARAM_OPERATOR.LESS_THAN,
    filterType: [FilterType.DATE, FilterType.NUMBER],
    icon: '/assets/images/svgs/operators/less-than.svg'
  },
  {
    name: 'greater than or equal',
    paramOperator: PARAM_OPERATOR.GREATER_THAN_OR_EQUAL,
    filterType: [FilterType.DATE, FilterType.NUMBER],
    icon: '/assets/images/svgs/operators/greater-than-or-equal.svg'
  },
  {
    name: 'less than or equal',
    paramOperator: PARAM_OPERATOR.LESS_THAN_OR_EQUAL,
    filterType: [FilterType.DATE, FilterType.NUMBER],
    icon: '/assets/images/svgs/operators/less-than-or-equal.svg'
  }
];

export const SYSTEM_TABS = {
  COUNTRIES: 'countries',
  ALLOCATION_TYPE: 'allocation type',
  DATA_PROVIDER: 'data provider',
  DATASET_TYPE: 'dataset type',
  DATASET_UNIT: 'dataset unit',
  DATA_SOURCE: 'data source'
};

export const DIALOG_WIDTH = {
  SMALLEST: '400px',
  SMALL: '500px',
  MEDIUM: '700px',
  LARGE: '900px',
  EXTRA_LARGE: '1100px'
};

export const topCardConfig: any = {
  process: {
    color: 'primary',
    icon: 'server-cog',
    iconColor: '#5D87FF',
    title: 'processes'
  },
  companies: {
    color: 'warning',
    icon: 'building',
    iconColor: '#FFA500',
    title: 'companies'
  },
  users: {
    color: 'secondary',
    icon: 'users',
    iconColor: '#3c9cd1',
    title: 'users'
  },
  userAdmin: {
    color: 'error',
    icon: 'user-cog',
    iconColor: '#FF0000',
    title: 'administrators'
  }
};

export const PROCESS_CHART_HEIGHT = 458.94 - 55 - 60.35;

export const PROCESS_CHART_BASE = {
  chart: {
    height: PROCESS_CHART_HEIGHT,
    width: '100%',
    type: "bar",
    foreColor: '#a1aab2',
    toolbar: { show: false }
  } as ApexChart,
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "55%",
      endingShape: "rounded"
    }
  },
  dataLabels: { enabled: false },
  stroke: {
    show: true,
    width: 2,
    colors: ["transparent"],
  },
  fill: { opacity: 1 },
  markers: { size: 4 },
  tooltip: {
    y: { formatter: (val: number) => val.toString() },
    theme: 'dark'
  } as ApexTooltip,
  legend: {
    show: false
  },
  grid: {
    show: true,
    strokeDashArray: 0,
    borderColor: 'rgba(0,0,0,0.1)'
  }
};

export const SUB_PROCESS_CHART_COLORS = ['#5D87FF', '#ECF2FF'];

export const USER_CHART_CONFIG = {
  chart: {
    type: 'area',
    height: 85,
    sparkline: { enabled: true },
    toolbar: { show: false },
    foreColor: '#adb0bb'
  },
  stroke: {
    curve: 'smooth',
    width: 2
  },
  fill: {
    colors: ['#E8F7FF'],
    opacity: 0.05,
    type: 'solid'
  },
  markers: { size: 0 },
  tooltip: {
    theme: 'dark',
    x: { show: false }
  }
};

export const MEDIA_MIME_BY_EXT: Record<string, string> = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  bmp: 'image/bmp',
  ico: 'image/x-icon',
  tiff: 'image/tiff',
  heic: 'image/heic',
  mp4: 'video/mp4',
  webm: 'video/webm',
  ogg: 'video/ogg',
  mov: 'video/quicktime',
  m4v: 'video/x-m4v'
};
